export { default as UserList } from './List';
export { default as UserCreate } from './Create';
export { default as UserUpdate } from './Update';
export { default as UserDetails } from './Details';